import React from "react";
import { Dialog, DialogTitle, DialogContent, Stack, Box, Tooltip, useTheme } from "@mui/material";

export default function AllEvents({ open, onClose, date, events, onEventClick }) {
  const theme = useTheme();

  const formatTime = (time) => {
    if (!time) return "";
    return String(time).slice(0, 5);
  };

  const getTimeRange = (evt) => {
    if (!evt.horaInicio) return "Todo el día";
    return evt.horaFin
      ? `${formatTime(evt.horaInicio)} - ${formatTime(evt.horaFin)}`
      : formatTime(evt.horaInicio);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Eventos del {date}</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={1}>
          {events.map((evt, i) => {
            const eventColor = evt.color || theme.palette.primary.main;
            return (
              <Box
                key={i}
                onClick={(e) => {
                  e.stopPropagation();
                  if (onEventClick) {
                    onEventClick(evt);
                    onClose();
                  }
                }}
                sx={{
                  bgcolor: `${eventColor}1A`,
                  color: eventColor,
                  borderLeft: `3px solid ${eventColor}`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 2,
                  px: 1,
                  py: 0.5,
                  borderRadius: "2px 4px 4px 2px",
                  fontSize: "0.85rem",
                  fontWeight: 500,
                  cursor: "pointer",
                  "&:hover": { filter: "brightness(0.95)" },
                }}
              >
                <Tooltip title={evt.titulo || ""} arrow enterDelay={350}>
                  <Box component="span" tabIndex={0} sx={{ minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {evt.titulo}
                  </Box>
                </Tooltip>
                <Box component="span" sx={{ flexShrink: 0, fontWeight: 600, fontSize: "0.78rem", opacity: evt.horaInicio ? 1 : 0.75 }}>
                  {getTimeRange(evt)}
                </Box>
              </Box>
            );
          })}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
